import http from "@core/fetch";
import { useData } from "@hooks/useData";
import { ISocialPost, SocialPosts as SocialPostsModel } from "@models/SocialPosts";
import { components } from "@apiSchema";
import { v4 as uuid } from "uuid";
import apiConfig from "@apiConfig";

type Response = components["schemas"]["SocialTopPostsResponseViewModel"];
type PostItem = components["schemas"]["SocialTopPostViewModel"];

const REQUEST_TYPE: keyof typeof apiConfig = 'get top food beverage posts';

function mapPost(post: PostItem): ISocialPost {
    return {
        id: post.id ?? uuid(),
        source: SocialPostsModel.getPostSource(post.site ?? ''),
        sentiment: 'neutral',
        text: post.text ?? '',
        date: post.publishedDate ?? '',
        engagement: post.engagementCount ?? 0,
        followersCount: post.followersCount ?? 0,
        url: post.url ?? '',
    };
}

async function getTopFoodBeveragePosts(): Promise<ISocialPost[]> {
    try {
        const response: Response = await http.get(REQUEST_TYPE);

        return (response?.posts ?? []).map(mapPost);
    } catch (err) {
        console.error(err);

        return [];
    }
}

export function useTopFoodBeveragePosts() {
    return useData<ISocialPost[]>([], getTopFoodBeveragePosts);
}
